import { gql } from 'apollo-boost';

export const DELETE_GROUP_NOTIFICATIONS = gql`
  mutation AdminGroupAnnouncementDelete($ids: [ID!]!) {
    admin_group_announcement_delete(input: { ids: $ids }) {
      message
    }
  }
`;
